import {
  createBackendRouteInvoker,
  resolveTransportForRoute,
} from '../../../../shared/backend/invoke';
import { invokeCallableRoute } from './transports/callable';
import { invokeHttpRoute } from './transports/http';
import { routeTable } from './routes';

export { resolveTransportForRoute };

export const invokeBackendRoute = createBackendRouteInvoker({
  routeTable,
  invokeCallableRoute,
  invokeHttpRoute,
});
